<template>
  <div class="app">
    <vue-progress-bar></vue-progress-bar>
    <core-header/>
    <div class="app-body">
      <core-sidebar :navItems="nav"/>
      <main class="main">
        <!-- <b-alert :show="environment != 'production'" variant="warning">Você está utilizando a base de homologação, para acessar o site correto vá para (site aqui)</b-alert> -->
        <core-breadcrumb />

        <div class="container-fluid alpha omega">
          <router-view></router-view>
        </div>
      </main>
      <core-aside/>
    </div>
    <!-- <core-footer/> -->
  </div>
</template>

<script>
  import navbar from '@/components/navbar/default'
  import navbarMarketing from '@/components/navbar/marketing'
  import { mapGetters } from 'vuex'
  import { isEmpty } from 'lodash'

  export default {
    data () {
      return {
        environment: ''
      }
    },

    created () {
      this.environment = process.env.NODE_ENV
    },

    computed: {

      ...mapGetters({
        loggedUser: 'auth/user'
      }),

      nav () {
        const self = this
        if (!isEmpty(self.loggedUser)) {
          const role = self.loggedUser.main_role.slug
          if (role === 'marketing') {
            return navbarMarketing.items
          } else {
            return navbar.items
          }
        }
      },

      name () {
        return this.$route.name
      },

      list () {
        return this.$route.matched
      }
    }
  }
</script>

<style lang="sass">
  html, body
    height: 100%;
</style>



// WEBPACK FOOTER //
// src/components/containers/ContainerDefault.vue